{
  "formatVersion": 1,
  "name": "blackline-relay",
  "displayName": "Relay Station",
  "description": "A comms relay station: three routes lead from each team's walled start into a shared middle and on to two bombsites, and the halves mirror each other, so neither side owns a better opening angle.",
  "visual": {
    "gltf": "/game/maps/blackline-relay.glb"
  },
  "environment": "day",
  "brushes": [
    {
      "kind": "box",
      "center": [
        0,
        -0.42,
        0
      ],
      "halfExtents": [
        28,
        0.4,
        22
      ],
      "material": "metal",
      "note": "Foundation"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.09,
        0
      ],
      "halfExtents": [
        27,
        0.09,
        21
      ],
      "material": "concrete",
      "note": "Courtyard"
    },
    {
      "kind": "box",
      "center": [
        -27,
        1.81,
        0
      ],
      "halfExtents": [
        0.5,
        1.8,
        22
      ],
      "material": "concrete",
      "note": "Perimeter end"
    },
    {
      "kind": "box",
      "center": [
        27,
        1.81,
        0
      ],
      "halfExtents": [
        0.5,
        1.8,
        22
      ],
      "material": "concrete",
      "note": "Perimeter end"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.8,
        21
      ],
      "halfExtents": [
        27,
        1.8,
        0.5
      ],
      "material": "concrete",
      "note": "Perimeter side"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.8,
        -21
      ],
      "halfExtents": [
        27,
        1.8,
        0.5
      ],
      "material": "concrete",
      "note": "Perimeter side"
    },
    {
      "kind": "box",
      "center": [
        -12,
        2,
        7
      ],
      "halfExtents": [
        5.5,
        2,
        2.5
      ],
      "material": "concrete",
      "note": "Service building"
    },
    {
      "kind": "box",
      "center": [
        -15,
        4.55,
        7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        -9,
        4.55,
        7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        -12,
        2,
        -7
      ],
      "halfExtents": [
        5.5,
        2,
        2.5
      ],
      "material": "concrete",
      "note": "Service building"
    },
    {
      "kind": "box",
      "center": [
        -15,
        4.55,
        -7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        -9,
        4.55,
        -7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        12,
        2,
        7
      ],
      "halfExtents": [
        5.5,
        2,
        2.5
      ],
      "material": "concrete",
      "note": "Service building"
    },
    {
      "kind": "box",
      "center": [
        9,
        4.55,
        7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        15,
        4.55,
        7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        12,
        2,
        -7
      ],
      "halfExtents": [
        5.5,
        2,
        2.5
      ],
      "material": "concrete",
      "note": "Service building"
    },
    {
      "kind": "box",
      "center": [
        9,
        4.55,
        -7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        15,
        4.55,
        -7
      ],
      "halfExtents": [
        1,
        0.4,
        0.75
      ],
      "material": "metal",
      "note": "Roof HVAC"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.25,
        15
      ],
      "halfExtents": [
        2.5,
        1.25,
        2
      ],
      "material": "metal",
      "note": "Relay island"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.25,
        -15
      ],
      "halfExtents": [
        2.5,
        1.25,
        2
      ],
      "material": "metal",
      "note": "Relay island"
    },
    {
      "kind": "box",
      "center": [
        -20,
        0.7,
        14
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.7,
        15
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.7,
        -15
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        20,
        0.7,
        -14
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        -20,
        0.7,
        -14
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        20,
        0.7,
        14
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.7,
        0
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.7,
        0
      ],
      "halfExtents": [
        1.15,
        0.7,
        0.9
      ],
      "material": "metal",
      "note": "Equipment cover"
    },
    {
      "kind": "box",
      "center": [
        -21,
        1.5,
        0
      ],
      "halfExtents": [
        0.5,
        1.5,
        3
      ],
      "material": "metal",
      "note": "Spawn screen"
    },
    {
      "kind": "box",
      "center": [
        21,
        1.5,
        0
      ],
      "halfExtents": [
        0.5,
        1.5,
        3
      ],
      "material": "metal",
      "note": "Spawn screen"
    }
  ],
  "spawns": [
    {
      "position": [
        -25,
        0,
        0
      ],
      "yaw": -0.771,
      "team": 0
    },
    {
      "position": [
        25,
        0,
        0
      ],
      "yaw": 2.371,
      "team": 1
    },
    {
      "position": [
        -23,
        0,
        -5
      ],
      "yaw": -1.785,
      "team": 0
    },
    {
      "position": [
        23,
        0,
        -6
      ],
      "yaw": 2.226,
      "team": 1
    },
    {
      "position": [
        -23,
        0,
        4
      ],
      "yaw": -1.399,
      "team": 0
    },
    {
      "position": [
        23,
        0,
        -3
      ],
      "yaw": 0.6,
      "team": 1
    },
    {
      "position": [
        -22.67,
        0,
        0
      ],
      "yaw": -0.771,
      "team": 0
    },
    {
      "position": [
        -23.67,
        0,
        -2
      ],
      "yaw": -0.771,
      "team": 0
    },
    {
      "position": [
        -23.67,
        0,
        2
      ],
      "yaw": -1.399,
      "team": 0
    },
    {
      "position": [
        -26.17,
        0,
        -2
      ],
      "yaw": -0.771,
      "team": 0
    },
    {
      "position": [
        -26.17,
        0,
        2
      ],
      "yaw": -0.771,
      "team": 0
    },
    {
      "position": [
        22.67,
        0,
        0
      ],
      "yaw": 2.371,
      "team": 1
    },
    {
      "position": [
        23.67,
        0,
        2
      ],
      "yaw": 2.371,
      "team": 1
    },
    {
      "position": [
        25.67,
        0,
        -2
      ],
      "yaw": 2.371,
      "team": 1
    },
    {
      "position": [
        26.17,
        0,
        2
      ],
      "yaw": 2.371,
      "team": 1
    },
    {
      "position": [
        20.17,
        0,
        0
      ],
      "yaw": 2.371,
      "team": 1
    }
  ],
  "props": [],
  "lights": [
    {
      "kind": "point",
      "position": [
        -25,
        5.8,
        18
      ],
      "color": "#bcece7",
      "intensity": 35,
      "distance": 12
    },
    {
      "kind": "point",
      "position": [
        -25,
        5.8,
        -18
      ],
      "color": "#bcece7",
      "intensity": 35,
      "distance": 12
    },
    {
      "kind": "point",
      "position": [
        25,
        5.8,
        18
      ],
      "color": "#bcece7",
      "intensity": 35,
      "distance": 12
    },
    {
      "kind": "point",
      "position": [
        25,
        5.8,
        -18
      ],
      "color": "#bcece7",
      "intensity": 35,
      "distance": 12
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        0,
        0.15,
        15
      ],
      "halfExtents": [
        5,
        0.5,
        4
      ]
    },
    {
      "id": "B",
      "center": [
        0,
        0.15,
        -15
      ],
      "halfExtents": [
        5,
        0.5,
        4
      ]
    }
  ]
}
